import React from "react";
import { withRouter } from "react-router";
import { SequenceCreateTab } from "./sequence-create";

/*
 * /Content/sequences/new: the start page of the sequence workspace (create-flow redesign 2026-10-08, PlunkDocs
 * mockups/create-flow-redesign-2026-10-08.html, Sequence screen). The whole page is SequenceCreateTab under .sn-view;
 * "Write the first cut" opens /Content/sequences/:id. Query: ?purpose=promo|tutorial|walkthrough|custom picks the kind,
 * ?pick=<assetId>[,<assetId>] pre-picks pieces and ?from=<label> names where they came from (the clip workspace's
 * "Use in a sequence").
 */
const qp = k => {
  try {
    return new URLSearchParams(window.location.search).get(k) || "";
  } catch (e) {
    return "";
  }
};
class SequenceNew extends React.Component {
  componentDidMount() {
    try {
      window.scrollTo(0, 0);
    } catch (e) {/* no window */}
  }
  picks() {
    const p = qp("pick");
    return p ? p.split(",").map(x => x.trim()).filter(Boolean) : [];
  }
  render() {
    const from = qp("from");
    return /*#__PURE__*/React.createElement("div", {
      className: "territory-view wa-view sn-view"
    }, /*#__PURE__*/React.createElement(SequenceCreateTab, {
      picks: this.picks(),
      purpose: qp("purpose") || undefined,
      notice: from ? /*#__PURE__*/React.createElement(React.Fragment, null, "Starting with ", /*#__PURE__*/React.createElement("b", null, from), " from the clip workspace. Pick more pieces to add them after it.") : null,
      onBack: () => this.props.history.push("/Content"),
      onCreated: seq => {
        if (seq && seq.id) this.props.history.replace(`/Content/sequences/${seq.id}`);
      }
    }));
  }
}
export default withRouter(SequenceNew);